export const BUILDER_API_KEY = import.meta.env.VITE_BUILDER_API_KEY;
